<template>
	<div class="menu" :class="{ 'menu--active': menuActive }">
		<div class="menu__buttons">
			<SwitchButton
				:toggle="colorMode == 'darkMode'"
				color="yellow"
				@click.native="toggleColorMode"
			>
				<template v-slot="on">
					<span class="icon-sun"></span>
				</template>
				<template v-slot="off">
					<span class="icon-moon"></span>
				</template>
			</SwitchButton>
			<SwitchButton
				:toggle="audio"
				color="blue"
				@click.native="toggleAudio"
			>
				<template v-slot="on">
					<span class="icon-sun"></span>
				</template>
				<template v-slot="off">
					<span class="icon-moon"></span>
				</template>
			</SwitchButton>

			<Button @click.native="restart = true" text="New game" />
		</div>

		<div class="highscores">
			<ul class="highscores__list">
				<li
					v-for="(score, idx) in highScores"
					:key="idx"
					class="highscores__item"
				>
					{{ score.score }}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import SwitchButton from '@/components/switch-button.vue'
import Button from '@/components/button.vue'
export default {
	components: {
		SwitchButton: SwitchButton,
		Button: Button,
	},
	computed: {
		menuActive() {
			return this.$store.state.ui.menu.active
		},
		colorMode: {
			get() {
				return this.$store.state.ui.settings.colorMode
			},
			set(value) {
				this.$store.dispatch('ui/setMode', value)
			},
		},
		highScores: {
			get() {
				return this.$store.getters['scores/getHighscores']
			},
		},
		audio: {
			get() {
				return this.$store.state.ui.settings.audio
			},
			set(bool) {
				this.$store.dispatch('ui/setAudio', bool)
			},
		},
		restart: {
			get() {
				return this.$store.state.ui.restart
			},
			set(bool) {
				this.$store.dispatch('ui/setRestart', bool)
			},
		},
		Settings() {
			return this.$store.state.ui.settings
		},
	},
	methods: {
		toggleAudio() {
			this.$store.dispatch('ui/toggleAudio')
		},
		toggleColorMode() {
			this.$store.dispatch('ui/toggleColorMode')
		},
	},
}
</script>

<style lang="scss">
@import 'henris';
@import 'guyn';
@import 'silicons';
@keyframes fixIosIn {
	from {
		left: 0;
	}
	to {
		left: -0.1px;
	}
}
@keyframes fixIosOut {
	from {
		left: -0.1px;
	}
	to {
		left: 0;
	}
}
.menu {
	position: fixed;
	left: 0;
	z-index: 2;
	height: 100vh;
	width: 100vw;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	background-image: linear-gradient(
		to bottom,
		$guyn-YellowLight 33%,
		$guyn-Nightblue 66%
	);
	background-size: 100vw 300vh;
	// background-size:
	animation: fixIosOut $base-transition forwards;
	clip-path: circle(0%);
	transition: clip-path $base-transition $base-cubic-bezier,
		background $base-transition $base-cubic-bezier;
	pointer-events: none;
	top: -100vh;

	.darkMode & {
		background-position: 0 -200vh;
	}
	.lightMode & {
		background-position: 0 0;
	}

	&--active {
		top: 0vh;
		pointer-events: all;
		animation: fixIosOut $base-transition forwards;
		clip-path: circle(100%);
	}
	&__buttons {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		.btn + .btn {
			margin-top: 1em;
		}
	}
}

.highscores {
	&__list {
		border: 1px solid red;
		display: flex;
		justify-content: column;
	}
	&__item {
		border: 1px solid red;
	}
}
@include silicon-volume-high('.icon-audio-on');
@include silicon-volume-off('.icon-audio-off');
@include silicon-arrow-basic-right('.icon-change');
@include silicon-reload('.icon-rotate');
@include silicon-close('.icon-delete');
@include silicon-weather-sun('.icon-sun');
@include silicon-moon('.icon-moon');
</style>
